export const getUserFullName = (firstName: string | null | undefined, lastName: string | null | undefined) => {
  return (
    firstName && lastName ? `${firstName} ${lastName}` :
      firstName ? `${firstName}` :
        lastName ? `${lastName}` : ''
  )
};
